import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=c91920ba&scoped=true"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=c91920ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91920ba",
  null
  
)

export default component.exports